import React from 'react';
import { Avatar, Box, ButtonBase, FormHelperText, Paper, Typography, useTheme } from '@mui/material';
import { Person, PhotoCameraOutlined } from '@mui/icons-material';

interface AvatarSettingProps {
  avatarUrl?: string;
  onSelectFile?: (file: File) => void;
  isError?: boolean;
  helperText?: string;
  placeholderImage?: React.ReactNode;
}

export const AvatarSetting = ({
  avatarUrl,
  onSelectFile = () => {},
  isError = false,
  helperText = '',
  placeholderImage = <Person sx={{ fontSize: 64 }} />,
}: AvatarSettingProps) => {
  const theme = useTheme();
  const avatarInputRef = React.useRef<any>();

  return (
    <>
      <Box sx={{ display: 'flex', alignItems: 'flex-end', paddingY: 2 }}>
        <Box sx={{ position: 'relative', width: 'fit-content', cursor: 'pointer' }}>
          <Paper sx={{ borderRadius: '100%', overflow: 'hidden' }}>
            <ButtonBase component="label" sx={{ padding: 0.4 }}>
              {avatarUrl ? (
                <Avatar
                  alt="user avatar"
                  src={avatarUrl}
                  sx={{ width: 80, height: 80, backgroundColor: theme.palette.grey[300] }}
                />
              ) : (
                <Avatar alt="no user avatar" sx={{ width: 80, height: 80, backgroundColor: theme.palette.grey[300] }}>
                  {placeholderImage}
                </Avatar>
              )}

              <input
                ref={avatarInputRef}
                type="file"
                hidden
                onChange={(event: any) => {
                  const [file] = event.target.files || [null];

                  if (file) {
                    onSelectFile(file);
                  }
                }}
              />
            </ButtonBase>
          </Paper>

          <Box
            sx={{
              backgroundColor: theme.palette.primary.main,
              width: 24,
              height: 24,
              borderRadius: 24,
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              position: 'absolute',
              bottom: 0,
              right: 0,
            }}
            onClick={() => {
              avatarInputRef?.current?.click();
            }}
          >
            <PhotoCameraOutlined sx={{ fontSize: 14, color: 'white' }} />
          </Box>
        </Box>

        <Box sx={{ marginLeft: 5 }}>
          <Typography color="textSecondary" sx={{ lineHeight: 1.5, fontSize: 12, marginBottom: 0.4 }}>
            Preferred Image Size: <span style={{ fontWeight: 600, color: theme.palette.grey[800] }}>256 x 256</span>
          </Typography>

          <Typography color="textSecondary" sx={{ lineHeight: 1.5, fontSize: 12, marginBottom: 0.4 }}>
            File Formats: <span style={{ fontWeight: 600, color: theme.palette.grey[800] }}>.jpg, .png, or .svg</span>
          </Typography>

          <Typography color="textSecondary" sx={{ lineHeight: 1.5, fontSize: 12 }}>
            Maximum size: <span style={{ fontWeight: 600, color: theme.palette.grey[800] }}>10MB</span>
          </Typography>
        </Box>
      </Box>

      {isError && helperText && <FormHelperText error={isError}>{helperText}</FormHelperText>}
    </>
  );
};
